import React from 'react'

export default function Spacer() {
  return <div className="max-w-full h-20 md:h-[160px]"></div>
}
